"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserReviews = void 0;
const react_redux_1 = require("react-redux");
const ProductSelector_1 = require("../../redux/product/selectors/ProductSelector");
const useFeefoWidget_1 = require("../../hooks/useFeefoWidget");
const UserReviews = () => {
    const { productCode } = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductDefaults)());
    const { renderFeefoWidget } = (0, useFeefoWidget_1.useFeefoWidget)(productCode, !!productCode);
    return renderFeefoWidget();
};
exports.UserReviews = UserReviews;
